<template>
	<div class="list_page">
		<div class="position ">
			<div class="w1">当前位置：
				<router-link :to="'home'">首页</router-link>>
				<a style="text-decoration: none;">{{nodeName}}</a>
				<!-- <router-link :to="'list?id='+nodeId">{{nodeName}}</router-link> -->
			</div>
		</div>


		<div class="w1"><!--w1 -->




			<div class="wrap_group1  mb_1"><!--wrap_group1 -->
				<div class="wrap_group1_L "><!--wrap_group1_L -->

					<div class="leftmenu"><!--leftmenu -->
						<div class="Nav  current">
							<l>{{nodeName}}</l>
						</div>
						<ul class="subContent" v-if="arrNodeTree.length>0">
							<li v-for="(item,index) in arrNodeTree" @click="changecol(item.fdnodeid,item.fdname)"
								:class="selId==item.fdnodeid?'on':''">
								<a>{{item.fdname}}</a>
							</li>
						</ul>

					</div><!--/leftmenu -->


				</div><!--/wrap_group1_L -->
				<div class="wrap_group1_R"><!--wrap_group1_R -->


					<div class="main_title">{{selName}}</div>

					<ul class="main_list1" v-loading="loadingMask"><!--main_list1 -->
						<li v-for="(item,index) in resultDataList">
							<data>
								<div class="d1">{{item.publishTime.substring(8,10)}}</div>
								<div class="d2">{{item.publishTime.substring(0,7)}}</div>
							</data>
							<cont>
								<h1><router-link :to="'detail?id='+item.id" target="_blank">{{ item.title }}</router-link></h1>
								<div class="source">{{item.source}}</div>
								<div class="info">{{item.content}}</div>
							</cont>
						</li>
					</ul><!--/main_list1 -->

					<div class="Page">
						<el-pagination background @size-change="changePageSize" @current-change="changeSearchPage"
							:current-page="pageNum" :page-size="pageSize" layout="total, prev, pager, next, jumper"
							:total="totalResultCount">
						</el-pagination>
					</div>

				</div><!--/index_group1_R -->
			</div><!--/wrap_group1 -->



		</div><!--/w1 -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: true,
				nodeId: '',
				nodeName: '',
				arrNodeTree: [],
				selId: '',
				selName: '',
				pageNum: 1,
				pageSize: 10,
				totalResultCount: 0,
				resultDataList: [],
			}
		},
		components: {

		},
		watch: {
			$route(to, from) {
				if (to.query.id != from.query.id) {
					this.getNodeTree();
				}
			}
		},
		created: function() {
			this.getNodeTree();
		},
		mounted: function() {
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		methods: {
			getNodeTree: function() {
				var _this = this;
				this.nodeId = this.$route.query.id;
				if (this.nodeId) {
					this.$http({
							method: 'get',
							url: 'chinaculturalindustrypromotion/tbappchanneltree/list',
							responseType: 'json',
							params: {

							},
						})
						.then(function(response) {
							if (response.data.code == 0) {
								_this.arrNodeTree = [];
								let temptree = response.data.page.list;
								for (var i = 0; i < temptree.length; i++) {
									if (temptree[i].fdnodeid == _this.nodeId) {
										_this.nodeName = temptree[i].fdname;
									}
									if (temptree[i].fdparentid == _this.nodeId) {
										_this.arrNodeTree.push(temptree[i]);
									}
								}
								if (_this.arrNodeTree.length > 0) {
									_this.changecol(_this.arrNodeTree[0].fdnodeid, _this.arrNodeTree[0].fdname);
								} else {
									_this.changecol(_this.nodeId, _this.nodeName);
								}
							} else {
								_this.arrNodeTree = [];
							}
						})
						.catch(function(error) {
							alert('数据获取出错！');
						});
				}
			},
			changecol: function(colid, colname) {
				this.selId = colid;
				this.selName = colname;
				this.pageNum = 1;
				this.pageSize = 10;
				this.getArticleList();
			},
			getArticleList: function() {
				this.loadingMask = true;
				var _this = this;
				this.$http({
						method: 'get',
						url: 'chinaculturalindustrypromotion/tbapparticleinfo/list',
						responseType: 'json',
						params: {
							nodeId: this.selId,
							pageIndex: this.pageNum,
							pageSize: this.pageSize,
						},
					})
					.then(function(response) {
						if (response.data.code == 0) {
							_this.resultDataList = response.data.list.data;
							_this.totalResultCount = response.data.list.totalcount;
						} else {
							_this.resultDataList = [];
							_this.totalResultCount = 0;
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.resultDataList = [];
						_this.totalResultCount = 0;
						_this.loadingMask = false;
						console.log('数据获取出错！');
					});
			},
			changePageSize: function(pagesize) {
				this.pageSize = pagesize;
				this.getArticleList();
			},
			changeSearchPage: function(page) {
				this.pageNum = page;
				this.getArticleList();
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
			},

		}
	}
</script>

<style>
</style>